import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const SecuredRoute = ({ component: Component, loggedUser, ...otherProps }) => {
  const securityReducer = useSelector((state) => state.security);
  const { validToken } = securityReducer;
  return (
    <Route
      {...otherProps}
      render={(props) =>
        validToken === true ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default SecuredRoute;
